<template>
  <div>
    <el-button @click="hitShow">招生方案</el-button>
  </div>
</template>

<script>
import { ElMessageBox } from "element-plus";
export default {
  setup() {
    const hitShow = () => {
      try {
        ElMessageBox.alert(
          "<p>更多招生方案详情请咨询</p><p>刘老师(微信):18019934025</p><p>徐老师(微信):13205515869</p><p>黄老师(微信):13075567156</p><p>刘校长(微信):18505513002</p>",
          "欢迎来到山河医学网",
          {
            dangerouslyUseHTMLString: true,
          }
        );
      } catch (error) {
        console.log(error);
      }
    };
    return { hitShow };
  },
};
</script>

<style lang="less" scoped></style>
